export const APP_ID = '217420945cc302ed';
export const REGION = 'us';
export const AUTH_KEY = '036863c674e669f0d2ace68130cf60e63c229608';
export const API_KEY = '5457c66d88856d35a615e6b41935be532f666bd4';
